const mediaItems = [
  {
    title: '科幻巨制《星际之门》4K预告',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20futuristic%20spaceship%20and%20nebula%20galaxy%2C%20dramatic%20space%20lighting%2C%20epic%20scale%2C%20professional%20cinematography%2C%20cinematic%20color%20grading%2C%20no%20text&width=800&height=450&seq=media-01-mv&orientation=landscape',
    tag: '4K蓝光',
    desc: '年度必看科幻大片，视觉震撼',
  },
  {
    title: '高分悬疑《暗夜追踪》超清上线',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20cinematic%20scene%20with%20noir%20lighting%2C%20rainy%20city%20street%20at%20night%2C%20dramatic%20shadows%2C%20film%20noir%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=450&seq=media-02-mv&orientation=landscape',
    tag: '蓝光画质',
    desc: '豆瓣8.7分烧脑神剧',
  },
  {
    title: '动漫剧场版《星辰之海》独家放送',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20cinematic%20scene%20with%20starry%20night%20sky%20and%20ocean%2C%20ethereal%20lighting%2C%20fantasy%20atmosphere%2C%20artistic%20composition%2C%20professional%20animation%20quality%2C%20no%20text&width=800&height=450&seq=media-03-mv&orientation=landscape',
    tag: '超清画质',
    desc: '现象级动漫剧场版全网首发',
  },
  {
    title: '国产热剧《长安风云》每日更新',
    image: 'https://readdy.ai/api/search-image?query=Epic%20historical%20Chinese%20drama%20cinematic%20scene%20with%20ancient%20palace%20architecture%2C%20warm%20golden%20hour%20lighting%2C%20period%20costume%20aesthetic%2C%20professional%20cinematography%2C%20no%20text&width=800&height=450&seq=media-04-mv&orientation=landscape',
    tag: '超清同步',
    desc: '古装权谋大戏持续热播中',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精彩预告</h2>
          <p className="mt-3 text-sm text-foreground-500">最新上线的高清影视内容抢先看</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden bg-background-200 aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-medium bg-primary-500 text-white rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-white"></i>
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}